import React, {Component} from 'react';

import { withRouter } from "react-router";
import SortByFilter from "../../../shared/sortbyfilter/components/SortByFilter";
import FilterCollectionsComponent from "../../../filtercollections/components/FilterCollectionsComponent";
import MenuCollectionComponent from "../../../menucollection/components/MenuCollectionComponent";
import ProductComponent from "../../../shared/products/components/ProductComponent";
import PropTypes from "prop-types"
import Pagination from "react-js-pagination";
import "../style/CollectionStyle.scss";
import LoadingComponent from "../../../shared/loading/components/LoadingComponent";

class CollectionComponent extends Component {

    constructor(props) {
        super(props);

        const search = this.props.location.search;
        const params = new URLSearchParams(search);
        const page = params.get('page');
        let pageNumber = page ? parseInt(page) : 1

        this.state = {
            collections: [],
            loading: true,
            stateParam: "",
            loadingCollection: true,
            collectionId: '',
            collection: '',
            activePage: pageNumber,
            lookBookUrl: "",
            pressRelease: "",
        };

    };

    componentDidMount(){
      if (this.state.activePage !== 1){
        this.handlePageChange(this.state.activePage)
      }
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps === undefined) {
            return false
        }

        const search = this.props.location.search;
        const params = new URLSearchParams(search);
        const page = params.get('page');

        let pageNumber = page ?  parseInt(page) : 1

        if (this.state.activePage !== pageNumber) {

          this.setState({activePage: pageNumber});
          this.props.setFilters("page", pageNumber)
        }

    }
    handlePageChange(pageNumber) {
        if (isNaN(pageNumber)){
          pageNumber = 1
        }
        this.setState({activePage: parseInt(pageNumber)});

        this.props.history.push({
           pathname: this.state.pathname,
           search: `?page=${pageNumber}`
         })
        this.props.setFilters("page", pageNumber)
    }

    setCurrentPageOne() {
        this.setState({ activePage: 1} );
        this.props.history.push({
           pathname: this.state.pathname,
           search: `?page=1`
         })
        this.props.setFilters("page", "1");

    }

    setCollection(id, lookbookurl, pressRelease) {
        this.setState({
            collectionId: id,
            lookBookUrl: lookbookurl,
            pressRelease: pressRelease
        });
        this.setCurrentPageOne();
    }

    render() {

        if(this.props.loadingProduct) {
            return (<LoadingComponent />)
        }

        return (
            <div>
                <main>
                    <section id="sotBy" className="centerComponent">
                        <SortByFilter
                            setFilters={this.props.setFilters.bind(this)}
                        />
                    </section>

                    <section id="mainCollection" className="centerComponent">
                        <div className="leftCollection">
                            <FilterCollectionsComponent
                                meta={this.props.results.meta}
                                collections={this.props.results.meta.collections}
                                isCollection={this.props.isCollection}
                                isBrand={this.props.isBrand}
                                isBrandPage={this.props.isBrandPage}
                                isSegment={this.props.isSegment}
                                setFilters={this.props.setFilters.bind(this)}
                                getFilters={this.props.getFilters.bind(this)}
                                getProducts={this.props.getProducts.bind(this)}
                                handleClick={this.props.handleClick.bind(this)}
                                clearAllFilter={this.props.clearAllFilter.bind(this)}
                                setCurrentPageOne={this.setCurrentPageOne.bind(this)}
                                endPoint={this.props.endPoint}
                                setCollection={this.setCollection.bind(this)}
                                collectionId={this.state.collectionId}
                            />
                        </div>

                        <div className="rightCollection">
                            {this.props.results.meta.selected_collection  && 'lookbook_url' in this.props.results.meta.selected_collection  &&
                            <MenuCollectionComponent
                                collections={this.props.results.meta}
                                collectionId={this.state.collectionId}
                                lookBookUrl={this.state.lookBookUrl}
                                pressRelease={this.state.pressRelease}
                                fullCollection={this.props.results.meta.selected_collection}
                            />
                            }

                            <ProductComponent
                                loading={this.props.loading}
                                pagination={this.props.results.pagination}
                                products={this.props.results.results}
                                setFilters={this.props.setFilters.bind(this)}
                                currentPage={this.props.currentPage}
                                isCheckBox={false}
                            />

                            {this.props.results.pagination.num_pages > 1 &&
                            <p className="results">
                                {this.props.results.pagination.count} results
                            </p>
                            }

                            {this.props.results.pagination.num_pages > 1 &&
                            <div className="contentPagination">
                                {this.props.results.pagination.previous &&
                                  <div  onClick={ () => this.handlePageChange(this.props.results.pagination.previous) } className="prevPagination">
                                      &#8227;
                                  </div>
                                }

                                <Pagination
                                    hideDisabled
                                    activePage={this.state.activePage}
                                    itemsCountPerPage="12"
                                    totalItemsCount={this.props.results.pagination.count}
                                    onChange={this.handlePageChange.bind(this)}
                                    hideNavigation
                                    hideFirstLastPages
                                />

                                {this.props.results.pagination.next &&
                                  <div onClick={ () => this.handlePageChange(this.props.results.pagination.next) } className="nextPagination">
                                        &#8227;
                                    </div>
                                  }
                            </div>
                            }

                        </div>
                    </section>
                </main>
            </div>
        );
    }
}

CollectionComponent.propType = {
    collection: PropTypes.array.isRequired,
    getFilters: PropTypes.func.isRequired
};

export default withRouter(CollectionComponent);
